export default __webpack_public_path__ + "static/slide5-4e8dfa4a09eb9d6aca9173c395e07f77.png";